const STORAGE_KEY = 'sheen_notification_history';
const MAX_ITEMS = 40;

export const NOTIFICATION_HISTORY_CHANGED = 'sheenNotificationHistoryChanged';

function safeParseList(raw) {
  try {
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

/**
 * @returns {boolean} true if the entry was stored (localStorage write succeeded)
 */
export function appendNotificationHistory(entry) {
  const item = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    createdAt: Date.now(),
    message: entry.message || '',
    title: entry.title || 'Notification',
    path: entry.path || '/profile',
    profileSection: entry.profileSection || null,
    kind: entry.kind || 'general',
    externalId: entry.externalId != null && entry.externalId !== '' ? String(entry.externalId) : null,
  };
  try {
    const list = safeParseList(localStorage.getItem(STORAGE_KEY));
    const next = [item, ...list].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    return false;
  }
  try {
    window.dispatchEvent(new CustomEvent(NOTIFICATION_HISTORY_CHANGED));
  } catch {
    /* ignore */
  }
  return true;
}

/** Skip append when `externalId` already exists (e.g. same server notification). */
export function appendNotificationHistoryIfNew(entry) {
  const ext = entry?.externalId;
  if (ext != null && String(ext).trim() !== '') {
    const key = String(ext).trim();
    const existing = getNotificationHistory(100);
    if (existing.some((x) => x.externalId && String(x.externalId) === key)) {
      return false;
    }
  }
  return appendNotificationHistory(entry);
}

export function getNotificationHistory(limit = 25) {
  try {
    const list = safeParseList(localStorage.getItem(STORAGE_KEY));
    const lim = Math.max(0, Math.min(100, limit));
    return list.slice(0, lim);
  } catch {
    return [];
  }
}
